/**
 * Choose Daycare block.
 *
 * Filters the location dropdown by the selected daycare type and points the
 * "Inschrijven" button at the chosen location's registration URL. All location
 * data is rendered into the block's `data-locations` attribute, so filtering
 * happens entirely client side.
 */
const chooseDaycare = ( root ) => {
  const select = root.querySelector( '.choose-daycare__select' );
  const submit = root.querySelector( '.choose-daycare__submit' );
  const radios = root.querySelectorAll( 'input[name="daycare-type"]' );

  if (!select || !submit || !radios.length) {
    return;
  }

  let locations = [];

  try {
    locations = JSON.parse( root.dataset.locations || '[]' );
  } catch ( error ) {
    locations = [];
  }

  const placeholder = select.dataset.placeholder || '';

  // A registration URL on another domain opens in a new tab and gets the same
  // external-link icon the global external-links component adds to static links.
  const isExternal = ( url ) => {
    try {
      return new URL( url, window.location.href ).host !== window.location.host;
    } catch ( error ) {
      return false;
    }
  };

  const setExternalIcon = ( external ) => {
    const existing = submit.querySelector( '.icon--external-link' );

    if (external && !existing) {
      const icon = document.createElement( 'span' );
      icon.classList.add( 'icon--external-link' );
      icon.setAttribute( 'role', 'img' );
      icon.setAttribute( 'aria-label', '(opent in nieuw venster)' );
      submit.appendChild( icon );
    } else if (!external && existing) {
      existing.remove();
    }
  };

  const setSubmitState = ( url ) => {
    if (url) {
      const external = isExternal( url );

      submit.setAttribute( 'href', url );
      submit.removeAttribute( 'aria-disabled' );

      if (external) {
        submit.setAttribute( 'target', '_blank' );
        submit.setAttribute( 'rel', 'noopener noreferrer' );
      } else {
        submit.removeAttribute( 'target' );
        submit.removeAttribute( 'rel' );
      }

      setExternalIcon( external );
    } else {
      submit.removeAttribute( 'href' );
      submit.setAttribute( 'aria-disabled', 'true' );
      submit.removeAttribute( 'target' );
      submit.removeAttribute( 'rel' );
      setExternalIcon( false );
    }
  };

  // Rebuild the native <select> options for the given type slug. Hiding
  // <option>s is unreliable across browsers, so we rebuild the list instead.
  const rebuild = ( type ) => {
    select.innerHTML = '';

    const placeholderOption = document.createElement( 'option' );
    placeholderOption.value = '';
    placeholderOption.textContent = placeholder;
    select.appendChild( placeholderOption );

    locations
      .filter( ( location ) => Array.isArray( location.types ) && location.types.includes( type ) )
      .forEach( ( location ) => {
        const option = document.createElement( 'option' );
        option.value = location.url;
        option.textContent = location.title;
        select.appendChild( option );
      } );

    select.value = '';
    setSubmitState( '' );
  };

  radios.forEach( ( radio ) => {
    radio.addEventListener( 'change', () => rebuild( radio.value ) );
  } );

  select.addEventListener( 'change', () => setSubmitState( select.value ) );

  submit.addEventListener( 'click', ( event ) => {
    if (submit.getAttribute( 'aria-disabled' ) === 'true') {
      event.preventDefault();
    }
  } );

  const checkedRadio = root.querySelector( 'input[name="daycare-type"]:checked' ) || radios[0];
  rebuild( checkedRadio.value );
};

const initChooseDaycare = () => {
  document.querySelectorAll( '.choose-daycare' ).forEach( chooseDaycare );
};

if (document.readyState === 'loading') {
  document.addEventListener( 'DOMContentLoaded', initChooseDaycare );
} else {
  initChooseDaycare();
}
